import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/checkoutUrl';
interface CtaButtonProps {
  label: string;
  variant?: 'primary' | 'soft';
  size?: 'md' | 'lg';
  className?: string;
  /** Ziel des Buttons. Standard: der Kauf-Link. Für einen Sprung auf der Seite z. B. "#angebot". */
  href?: string;
}
export function CtaButton({
  label,
  variant = 'primary',
  size = 'lg',
  className = '',
  href = checkoutUrl
}: CtaButtonProps) {
  const palette = variant === 'primary' ? 'bg-emerald text-white hover:bg-emerald-dark focus-visible:outline-emerald' : 'bg-mint text-forest hover:bg-emerald hover:text-white focus-visible:outline-emerald';
  const dims = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg' : 'px-6 py-4 text-base';
  const isAnchor = href.startsWith('#');
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAnchor) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    event.preventDefault();
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  };
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-3 rounded-lg text-center font-semibold tracking-tight shadow-lg shadow-emerald/20 transition-[transform,background-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 ${palette} ${dims} ${className}`} style={{
    paddingTop: "23px",
    paddingBottom: "23px",
    paddingLeft: "18px",
    paddingRight: "18px",
    marginTop: "4px",
    marginBottom: "4px",
    gap: "18px",
    backgroundColor: "#048A16",
    backgroundImage: "none"
  }} data-id="element-10" data-mp="3ewj5q6fv1cmo">
      <span style={{
      fontSize: "18px"
    }} data-id="element-11" data-mp="ge46tuj6uvzi">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-12" data-mp="3myifva05yq7s" />
    </a>;
}